import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { colorFilterHexes } from "../config"
import { capitalize } from "../helpers"

export default function ColorFacet({ facet }) {
    const { toggleProductFilter } = useFacet(facet);

    return (
        <div className="p-0 m-0">
            <div className="text-sm text-grey-3" data-nosto-element="facet">
                {facet.name}
            </div>    
            <ul className="list-none grid grid-cols-2 gap-2 m-0 p-0 mt-4">
                {facet.data?.map(value => {
                    const colorName = value.value.toLowerCase().replaceAll(' ', '-');
                    return (
                        <li
                            className="p-0 m-0"
                            data-nosto-element="facet-setting"
                        >
                            <label 
                                className={`ns-facet__color-filter flex items-center gap-2.5 w-full p-2 text-sm cursor-pointer ${value.selected ? 'border border-grey-2 !rounded' : ''}`}
                            >
                                <span
                                    className={`w-4 h-4 rounded-sm bg-${colorName}-swatch`}
                                    style={`background: ${colorFilterHexes[value.value.toLowerCase()]};`}
                                />
                                <span>{capitalize(value.value)}</span>
                                <input 
                                    className="sr-only visually-hidden"
                                    type="checkbox"
                                    checked={value.selected} 
                                    onChange={(e) => {
                                        e.preventDefault();
                                        toggleProductFilter(facet.field, value.value, !value.selected)
                                    }} 
                                />
                            </label>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}
